import React, { Component } from "react";
import ReactModal from "react-modal";
import AddOrganizationModal from "../modals/add-organizations-modal/add-organizations-modal";
import ListReportModal from "../modals/report-modal/list-report-modal";
import Addresidualmodal from "../modals/add-residual-modal/add-residual-modal";
import AddResidualMassUploadsModal from "../modals/add-residual-mass-uploads/add-residual-mass-uploads-modal";

import {
    GetAllOrganizations,
    GetOrganizationById,
    Logout,
    ResidualFileGet,
    SearchOrganization,
    UserData,
    leadOwners,
    orgUsers,
} from "../../api";
import Header from "../preapps/Header";
import OrganizationsPage from "./organization-page/organization-page";
ReactModal.setAppElement("#root");

class Organizations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            showOrganizationModal: false,
            showReportModal: false,
            showAddResidueModal: false,
            showAddResidualMassUploadsModal: false,
            organization_user: [],
            pci_admin: false,
            isEditView: true,
            CurrentYear: new Date().getFullYear(),
            Months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            ResidualArray: [],
            listOrganizations: [],
            listOrganizationUsers: [],
            selectedOrganization: undefined,
            selectedOrganization_id: "",
            totalOrganization: 0,
            PageBeforeSearch: 0,
            isPcAdmin: false,
            orgUsers: [],
            listLeadOwner: [],
            is_ems_pc_admin: false,
        };
    }

    getLeadOwner = () => {
        leadOwners().then((res) => {
            if (Array.isArray(res?.data)) {
                this.setState({ listLeadOwner: res.data });
            }
        });
    };

    componentDidMount() {
        UserData().then((response) => {
            this.getOrganizationsList(1);
            this.getOrganizationData(response.organization_id);
            this.getOrgUsers();
            this.getLeadOwner();
        });
    }

    getOrgUsers = () => {
        orgUsers().then((res) => {
            this.setState({ orgUsers: res.users });
        });
    };

    populateLocalArray(CurrentYear) {
        var ResidualFinalArray = [];
        if (ResidualFinalArray[CurrentYear] === undefined) {
            ResidualFinalArray[CurrentYear] = [];
        }
        for (var i = 1; i <= 12; i++) {
            ResidualFinalArray[CurrentYear][i] = 0;
        }
        return ResidualFinalArray;
    }

    getOrganizationData(organization_id) {
        var ResidualFinalArray = [];
        const data = {
            organization_id: organization_id,
            year: this.state.CurrentYear,
        };
        GetOrganizationById(organization_id)
            .then((response) => {
                const organizationData = response;
                this.setState({
                    selectedOrganization: organizationData.organization,
                    organization_user: organizationData.users,
                    isEditView: true,
                });
                ResidualFileGet(data)
                    .then((response) => {
                        if (response.success) {
                            const residual_data = response.data;
                            if (residual_data.length == 0) {
                                ResidualFinalArray = this.populateLocalArray(
                                    this.state.CurrentYear,
                                );
                            } else {
                                residual_data.map((item) => {
                                    if (
                                        ResidualFinalArray[item.year] ===
                                        undefined
                                    ) {
                                        ResidualFinalArray[item.year] = [];
                                    }
                                    ResidualFinalArray[item.year][item.month] =
                                        item.uploaded;
                                });
                            }
                            this.setState({
                                ResidualArray: ResidualFinalArray,
                            });
                        }
                    })
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }

    getOrganizationsList(pageNumber) {
        this.setState({
            PageBeforeSearch: pageNumber,
        });
        UserData()
            .then((response) => {
                let isAdmin =
                    response.organization_id === 1 && response.role === "admin"
                        ? true
                        : false;
                let user = response;
                this.setState({ is_ems_pc_admin: user.is_ems_pc_admin });
                GetAllOrganizations(pageNumber)
                    .then((response) => {
                        this.setState({
                            user: user,
                            isPcAdmin: isAdmin,
                            totalOrganization: response.organization.total,
                            listOrganizationUsers: response.users,
                            listOrganizations: response.organization.data,
                        });
                        if (this.state.isEditView) {
                            this.getOrganizationData(
                                this.state.selectedOrganization.id,
                            );
                        }
                    })
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }

    handleEditOrgnization(evt) {
        this.props.history.push(`/organization/${evt}`);
    }

    handleSearchEvent(evt) {
        if (evt !== "") {
            SearchOrganization(evt)
                .then((response) => {
                    this.setState({
                        totalOrganization: response.organization.total,
                        listOrganizationUsers: response.users,
                        listOrganizations: response.organization.data,
                    });
                })
                .catch((error) => console.log(error));
        } else {
            if (this.state.PageBeforeSearch > 0) {
                this.getOrganizationsList(this.state.PageBeforeSearch);
            } else {
                this.getOrganizationsList(1);
            }
        }
    }

    handlePaginationClickClick(evt) {
        this.getOrganizationsList(evt);
    }

    logout() {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => console.log(error));
    }

    updateOrganizationsList = (response) => {
        this.setState({
            totalOrganization: response.organization.total,
            listOrganizationUsers: response.users,
            listOrganizations: response.organization.data,
        });
    };

    showReportModalClose = () => {
        this.setState({ showReportModal: false, selectedOrganization_id: "" });
    };

    render() {
        const {
            totalOrganization,
            isPcAdmin,
            user,
            isEditView,
            listOrganizationUsers,
            listOrganizations,
            showOrganizationModal,
            showReportModal,
            showAddResidueModal,
            organization_user,
            selectedOrganization,
            selectedOrganization_id,
            orgUsers,
            showAddResidualMassUploadsModal,
            listLeadOwner,
        } = this.state;
        const { is_ems_pc_admin } = this.state;
        return (
            <div>
                {showOrganizationModal && (
                    <AddOrganizationModal
                        organization_user={organization_user}
                        selectedOrganization={selectedOrganization}
                        updateOrganizations={() => {
                            this.getOrganizationsList(1);
                            this.setState({ showOrganizationModal: false });
                        }}
                        handleClose={() =>
                            this.setState({ showOrganizationModal: false })
                        }
                        show={showOrganizationModal}
                    />
                )}
                {showReportModal && (
                    <ListReportModal
                        handleClose={this.showReportModalClose}
                        show={showReportModal}
                    />
                )}
                {showAddResidueModal && (
                    <Addresidualmodal
                        selectedOrganization_id={selectedOrganization_id}
                        handleClose={() =>
                            this.setState({
                                showAddResidueModal: false,
                                selectedOrganization_id: "",
                            })
                        }
                        show={showAddResidueModal}
                    />
                )}
                {showAddResidualMassUploadsModal && (
                    <AddResidualMassUploadsModal
                        show={showAddResidualMassUploadsModal}
                        handleClose={() =>
                            this.setState({
                                showAddResidualMassUploadsModal: false,
                            })
                        }
                        selectedOrganization_id={selectedOrganization_id}
                    ></AddResidualMassUploadsModal>
                )}
                {isEditView && (
                    <OrganizationsPage
                        isPcAdmin={isPcAdmin}
                        user={user}
                        listLeadOwner={listLeadOwner}
                        handlePaginationClickClick={(evt) =>
                            this.handlePaginationClickClick(evt)
                        }
                        totalOrganization={totalOrganization}
                        handleSearchEvent={(evt) => this.handleSearchEvent(evt)}
                        updateMembers={() => this.getOrganizationsList(1)}
                        updateOrganizations={() => this.getOrganizationsList(1)}
                        listOrganizationUsers={listOrganizationUsers}
                        listOrganizations={listOrganizations}
                        onEditClick={(evt) => this.handleEditOrgnization(evt)}
                        showOrganizationModal={(evt) =>
                            this.setState({
                                showOrganizationModal: evt,
                                selectedOrganization: undefined,
                            })
                        }
                        showAddResidueModal={(evt) =>
                            this.setState({
                                selectedOrganization_id: evt,
                                showAddResidueModal: true,
                            })
                        }
                        showReportModal={(evt) =>
                            this.setState({
                                selectedOrganization_id: evt,
                                showReportModal: true,
                            })
                        }
                        showAddResidualMassUploadsModal={(evt) =>
                            this.setState({
                                showAddResidualMassUploadsModal: true,
                            })
                        }
                        updateOrganizationsList={(data) =>
                            this.updateOrganizationsList(data)
                        }
                        orgUsers={orgUsers}
                        is_ems_pc_admin={is_ems_pc_admin}
                    />
                )}
            </div>
        );
    }
}
export default Organizations;
